export interface TargetGroup {
    id: number;
    label: string;
}

export class TargetGroupModel {
    public id: number;
    public label: string;

    constructor({
                    id,
                    label,
                }: TargetGroup) {
        this.id = id;
        this.label = label;
    }
}
